/* eslint-disable */
// Projects selection workspace — UI state (Convention #9: cross-component UI
// state lives in Zustand, not useState). Data lives in React Query (hooks/).
//
// activeList : null | 'in' | 'order' | 'preorder' | 'out' | 'all'  (decision-list view)
// search     : hero search text (immediate; debounced before queries)
// typeFilter : 'all' | 'Sun' | 'Optic'
// brandFilter: 'all' | <brand>
// revisitOnly: boolean
// modalDevId : uuid | null  (open detail modal)
// exportOpen : boolean      (Export Studio modal)

import { create } from 'zustand';

export const useProjectsUiStore = create((set) => ({
  // Sub-tool router (mirrors developments devView): 'selection' | 'sellsheets'.
  // Set by AppHeader.handleSubsectionClick; reset to 'selection' on portal switch.
  chooserOpen: false,
  openChooser: () => set({ chooserOpen: true }),
  closeChooser: () => set({ chooserOpen: false }),
  projectsView: 'selection',
  setProjectsView: (v) => set({ projectsView: v }),

  activeList: null,
  search: '',
  typeFilter: 'all',
  brandFilter: 'all',
  revisitOnly: false,
  modalDevId: null,
  exportOpen: false,
  applyOpen: false,

  // Clicking a decision toggle: open that list (and clear search), or toggle it off.
  setActiveList: (k) => set((s) => ({ activeList: s.activeList === k ? null : k, search: '' })),
  setSearch: (v) => set({ search: v }),
  setTypeFilter: (v) => set({ typeFilter: v }),
  setBrandFilter: (v) => set({ brandFilter: v }),
  toggleRevisitOnly: () => set((s) => ({ revisitOnly: !s.revisitOnly })),
  clearSearch: () => set({ search: '' }),
  openModal: (id) => set({ modalDevId: id }),
  closeModal: () => set({ modalDevId: null }),
  openExport: () => set({ exportOpen: true }),
  closeExport: () => set({ exportOpen: false }),
  openApply: () => set({ applyOpen: true }),
  closeApply: () => set({ applyOpen: false }),
}));
